import { getAdminAxiosInstance } from '../../../api/Admin';

export const getSeasonalThemeImage = async (params) => {
  const api = await getAdminAxiosInstance();
  try {
    const response = await api.post(`/seasonal-theme/upload-image`, params);
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const createSeasonalTheme = async (params) => {
  const api = await getAdminAxiosInstance();
  try {
    const response = await api.post(`/seasonal-theme/store`, params);
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const deleteSeasonalTheme = async (id) => {
  const api = await getAdminAxiosInstance();

  try {
    const response = await api.delete(`/seasonal-theme/delete?theme_id=${id}`);
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};